import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-670507c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-container" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = { class: "name-label" }
const _hoisted_4 = { class: "user-name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/settings.png",
    srcset: "/assets/icon/settings@2x.png 2x,/assets/icon/settings@3x.png 3x"
  })
], -1))
const _hoisted_6 = { class: "user_wrap" }
const _hoisted_7 = {
  id: "userInfo",
  ref: "walletBox"
}
const _hoisted_8 = { class: "invest-info" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-money" }, null, -1))
const _hoisted_10 = { class: "invest-box" }
const _hoisted_11 = {
  ref: "pointBox",
  class: "point-box"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 포인트 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "- P", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn_w",
  src: "/assets/icon/btn_right_w.png",
  srcset: "/assets/icon/btn_right_w@2x.png 2x,/assets/icon/btn_right_w@3x.png 3x"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 초대 · 할인코드 입력 ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 나의 초대링크 공유 ", -1))
const _hoisted_17 = { class: "main-container" }
const _hoisted_18 = { class: "main_padding" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "angel_b",
  src: "/assets/icon/angel_b.png",
  srcset: "/assets/icon/angel_b@2x.png 2x,/assets/icon/angel_b@3x.png 3x"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "g-color" }, "엔젤리그 거래방법 A to Z 한 눈에 보기 >", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "lock_box" }
const _hoisted_23 = { class: "login-info" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "lock",
    src: "/assets/image/lock.png",
    srcset: "/assets/image/lock@2x.png 2x,/assets/image/lock@3x.png 3x"
  })
], -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 로그인 하시면 자산 현황을 볼 수 있어요 ")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, " 거래 현황 "),
  /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
    /*#__PURE__*/_createElementVNode("span", null, "상세보기"),
    /*#__PURE__*/_createElementVNode("img", {
      class: "right_btn",
      src: "/assets/icon/btn_right.png",
      srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
    })
  ])
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nbox-radius" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inline-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "circle" }, " 0 "),
    /*#__PURE__*/_createElementVNode("div", { class: "content-text" }, " 협의중 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "inline-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "circle" }, " 0 "),
    /*#__PURE__*/_createElementVNode("div", { class: "content-text" }, " 조합설립중 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "inline-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "circle" }, " 0 "),
    /*#__PURE__*/_createElementVNode("div", { class: "content-text" }, " 서명중 ")
  ])
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, " 투자 자산 현황 "),
  /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
    /*#__PURE__*/_createElementVNode("span", null, "상세보기"),
    /*#__PURE__*/_createElementVNode("img", {
      class: "right_btn",
      src: "/assets/icon/btn_right.png",
      srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
    })
  ])
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wbox-radius" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wbox-content divide-margin" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "comb-title" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "comb-status" }, "조합원 자격 보유"),
      /*#__PURE__*/_createElementVNode("span", { class: "comb-money" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "-"),
        /*#__PURE__*/_createTextVNode(" 원 ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "wbox-content divide-margin" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "comb-title" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "comb-status" }, "조합 설립중"),
      /*#__PURE__*/_createElementVNode("span", { class: "comb-money" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "-"),
        /*#__PURE__*/_createTextVNode(" 원 ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "wbox-content divide-margin" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "comb-title" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "comb-status" }, "EXIT"),
      /*#__PURE__*/_createElementVNode("span", { class: "comb-money" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "-"),
        /*#__PURE__*/_createTextVNode(" 원 ")
      ])
    ])
  ])
], -1))
const _hoisted_30 = { class: "main-title" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, " 스톡옵션 ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "상세보기", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn",
  src: "/assets/icon/btn_right.png",
  srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
}, null, -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "wbox-radius" }
const _hoisted_36 = { class: "wbox-content" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comb-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "comb-status" }, "보유현황")
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "스톡옵션 세금계산기 > ", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 1:1 문의 ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" 해외 사용자를 위한 로그인 > ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("발급 받은 코드를 입력하세요")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 해외 사용자용 코드가 필요한가요? ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 1:1 문의 ")
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 해주세요 ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 닫기 ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" 로그인 하기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ag_footer = _resolveComponent("ag-footer")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_modal = _resolveComponent("ag-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", {
                    class: "bold",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단 투자금액&포인트영역', 'clickContent':'로그인'}); _ctx.$global.openLoginModal()})
                  }, "로그인 >")
                ]),
                _createVNode(_component_router_link, {
                  class: "ion-activatable ripple-parent",
                  to: "/settings",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'설정버튼영역', 'clickContent':'설정버튼클릭'});})
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ag_box_s, {
                          class: "ion-activatable ripple-parent point-box-item",
                          css: {p: 16, color: 'white'},
                          onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단 투자금액&포인트영역', 'clickContent':'포인트클릭'});_ctx.$global.openLoginModal()})
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12,
                            _createVNode(_component_ag_box_s, {
                              class: "charge-money",
                              css: {opacity:0.3}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13,
                                _hoisted_14
                              ]),
                              _: 1
                            }, 8, ["css"]),
                            _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ag_box_s, { css: {height: 1, width: '100%', bg: 'white', opacity: 0.2} }, null, 8, ["css"]),
                        _createVNode(_component_ag_box_s, { css: {dp: 'flex', direction: 'row', p: 16} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ag_box_s, {
                              css: {typography: 'tit14b', grow: 1, textAlign: 'center'},
                              class: "ion-activatable ripple-parent",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단 투자금액&포인트영역', 'clickContent':'초대할인코드입력'});_ctx.$global.openLoginModal()})
                            }, {
                              default: _withCtx(() => [
                                _hoisted_15,
                                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ag_box_s, { css: {width: 1, height: 12, bg: 'white', opacity: 0.2, margin: 'auto'} }, null, 8, ["css"]),
                            _createVNode(_component_ag_box_s, {
                              "container-as": "button",
                              css: {typography: 'tit14b', grow: 1, textAlign: 'center', bg: 'transparent', color: 'white'},
                              class: "ion-activatable ripple-parent",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단 투자금액&포인트영역', 'clickContent':'나의초대링크공유'});_ctx.$global.openLoginModal()})
                            }, {
                              default: _withCtx(() => [
                                _hoisted_16,
                                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 512)
                    ])
                  ])
                ], 512)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", {
                class: "gbox-radius",
                onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'노티스영역', 'clickContent':'조합지분사고팔기AtoZ한눈에보기'}); _ctx.openLink('https://abit.ly/appbanner_shake')})
              }, _hoisted_21),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      class: "login_btn",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'로그인영역', 'clickContent':'로그인'}); _ctx.$global.openLoginModal()})
                    }, " 로그인 ")
                  ]),
                  _hoisted_25
                ])
              ]),
              _hoisted_26,
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", {
                  class: "right",
                  onClick: _cache[7] || (_cache[7] = () => {
                _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'스톡옵션', 'clickContent':'상세보기'})
                _ctx.router.push({name:'StockOption'})
              })
                }, _hoisted_34)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", {
                    class: "stock-info",
                    onClick: _cache[8] || (_cache[8] = () => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'스톡옵션', 'clickContent':'스톡옵션세금계산기'})
                  _ctx.router.push({name:'StockOption', params : {scroll: 'calc'}})
                })
                  }, _hoisted_39)
                ])
              ]),
              _hoisted_40
            ]),
            _createVNode(_component_ag_box, {
              dp: "flex",
              gap: "sp4",
              px: "20px",
              pt: "24px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_button, {
                  typography: "tit14b",
                  width: "100%",
                  fill: "indigo1",
                  onClickCapture: _cache[9] || (_cache[9] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단설명영역', 'clickContent':'1:1문의'}); _ctx.openChannelTalk()})
                }, {
                  default: _withCtx(() => [
                    _hoisted_41
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ag_box, {
              mx: "20px",
              p: "10px",
              color: "font",
              dp: "flex",
              "justify-content": "flex-start",
              "align-items": "center",
              onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'해외사용자로그인영역', 'clickContent':'해외사용자로그인'}); _ctx.setOpenCodeLogin(true)})
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, { icon: _ctx.globeOutline }, null, 8, ["icon"]),
                _createVNode(_component_ag_text, { ml: "4px" }, {
                  default: _withCtx(() => [
                    _hoisted_42
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ag_modal, {
        "model-value": _ctx.isOpenCodeLogin,
        "backdrop-dismiss": "",
        "swipe-to-close": "",
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.setOpenCodeLogin(false)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_header, { handle: "" }),
          _createVNode(_component_ag_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_ag_box, { p: "10px" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_text, null, {
                    default: _withCtx(() => [
                      _hoisted_43
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box, {
                    bg: "gray5",
                    mt: "7px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        inputmode: "text",
                        mode: "md",
                        placeholder: "발급 받은 코드 예) GLLE4U67e",
                        onIonInput: _ctx.setExceptionToken
                      }, null, 8, ["onIonInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_text, {
                    color: "gray2",
                    typography: "main12r"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_44
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_text, {
                    color: "gray1",
                    typography: "main12r",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.closeCodeLoginAndOpenChannelTalk()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_45
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_text, {
                    color: "gray2",
                    typography: "main12r"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_46
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ag_footer, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_box, {
                    width: "100%",
                    dp: "flex"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_button, {
                        corner: "0",
                        grow: "1",
                        bg: "gray3",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setOpenCodeLogin(false)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_47
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_button, {
                        corner: "0",
                        grow: "1",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.getUuidByExceptionToken()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_48
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model-value"])
    ]),
    _: 1
  }))
}